<script lang="ts">
    import { Link } from "../routing";
    import type { RouteLocation } from "../routing/route_location";
    export let location: RouteLocation;
    export let url: string;

    const activeRegex = new RegExp(`^${url}/?$`);
    $: active = location.pathname.match(activeRegex) != null;
</script>

<Link to={url}><slot /></Link>
